import { Badge, Flex } from '@chakra-ui/react'

export interface INpsBandsProps {
  promoters: number
  passives: number
  detractors: number
}

/** As três faixas que compõem o NPS do card, para a conta ficar auditável na própria tela. */
export default function NpsBands({ promoters, passives, detractors }: INpsBandsProps) {
  return (
    <Flex gap="2" mt="3" flexWrap="wrap">
      <Badge colorScheme="green">
        {promoters.toLocaleString('pt-BR')} {promoters === 1 ? 'promotor' : 'promotores'}
      </Badge>
      <Badge colorScheme="gray">
        {passives.toLocaleString('pt-BR')} {passives === 1 ? 'passivo' : 'passivos'}
      </Badge>
      <Badge colorScheme="red">
        {detractors.toLocaleString('pt-BR')} {detractors === 1 ? 'detrator' : 'detratores'}
      </Badge>
    </Flex>
  )
}
